(function(ns) {
	"use strict";

	var util = ns.util;

	var computed = {
		ruleName: function() {
			if (!this.error) {
				return null;
			}
			var args = this.error.split(/:/g);
			return args.shift();
		}
	};

	for (var i = 1; i <= 9; i++) {
		computed["arg" + i] = createArgFn(i);
	}

	function createArgFn(index) {
		return function() {
			if (!this.error) {
				return null;
			}
			var args = this.error.split(/:/g);
			return (args.length > index) ? args[index] : null;
		};
	}

	util.component("invalid-feedback", {
		props: {
			error: String,
		},
		data: function() {
			return {
			};
		},
		computed: computed
	});

})(CE);
